import { EmptyState } from '@/components/shared/EmptyState'
import { usePermission } from '@/hooks/usePermission'
import { ShieldOff } from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  permission: string
  children: ReactNode
  fallback?: ReactNode
}

export function RequirePermission({ permission, children, fallback }: Props) {
  const allowed = usePermission(permission)
  const { t } = useTranslation('common')
  if (allowed) return <>{children}</>
  return (
    <>
      {fallback ?? (
        <EmptyState
          icon={ShieldOff}
          title={t('permissions.denied_title', { defaultValue: 'Access denied' })}
          description={t('permissions.denied_description', {
            defaultValue: 'You do not have the required permission.',
          })}
        />
      )}
    </>
  )
}
